export default "__VITE_ASSET__C3VYE_Sh__"